import axios from 'axios'
import { visualizationUrls } from '@/api/urls'

const options = { headers: { 'Content-Type': 'application/json' }, withCredentials: true }

export const getVisualization = (id) => axios.get(visualizationUrls.getVisualization(id), options)

export default {
  getVisualization
}
